var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-contact-distributions" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c(
        "div",
        { staticClass: "chart-container" },
        [
          _c(
            "div",
            { staticClass: "chart-section", attrs: { id: "time-section" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.timeDistribution")))]),
              _vm._v(" "),
              _c("ContactDistributionsByTime", {
                attrs: {
                  title: _vm.$t("report.timeDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byTime,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section", attrs: { id: "channel-section" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.channelDistribution")))]),
              _vm._v(" "),
              _c("ContactDistributionsByChannel", {
                attrs: {
                  title: _vm.$t("report.channelDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byChannel,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section", attrs: { id: "tag-section" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.tagDistribution")))]),
              _vm._v(" "),
              _c("ContactDistributionsByTag", {
                attrs: {
                  title: _vm.$t("report.tagDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byTag,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section", attrs: { id: "platform-section" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.platformDistribution")))]),
              _vm._v(" "),
              _c("ContactDistributionsByPlatform", {
                attrs: {
                  title: _vm.$t("report.platformDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byPlatform,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section", attrs: { id: "owner-section" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.ownerDistribution")))]),
              _vm._v(" "),
              _c("ContactDistributionsByOwner", {
                attrs: {
                  title: _vm.$t("report.ownerDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byOwner,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section", attrs: { id: "language-section" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.languageDistribution")))]),
              _vm._v(" "),
              _c("ContactDistributionsByLanguage", {
                attrs: {
                  title: _vm.$t("report.languageDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byLanguage,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section", attrs: { id: "ads-section" } },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.adsDistribution")))]),
              _vm._v(" "),
              _c("ContactDistributionsByAd", {
                attrs: {
                  title: _vm.$t("report.adsDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byAd || [],
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section", attrs: { id: "property-section" } },
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("report.contactPropertyDistribution"))),
              ]),
              _vm._v(" "),
              _c("ContactDistributionsByContactProperty", {
                attrs: {
                  title: _vm.$t("report.contactPropertyDistribution"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byContactProperty,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "section-navigator" },
      _vm._l(_vm.sections, function (section, index) {
        var _obj
        return _c(
          "div",
          {
            key: section.id,
            staticClass: "nav-item",
            class:
              ((_obj = {
                active: _vm.activeSection === section.id,
              }),
              (_obj["section-color-" + (index + 1)] = true),
              _obj),
            attrs: { title: section.title },
            on: {
              click: function ($event) {
                return _vm.scrollToSection(section.id)
              },
            },
          },
          [
            _c("div", { staticClass: "invisible-hover-area" }),
            _vm._v(" "),
            _c("div", { staticClass: "nav-line" }),
            _vm._v(" "),
            _c("div", { staticClass: "nav-overlay" }, [
              _c("span", { staticClass: "nav-text" }, [
                _vm._v(_vm._s(section.title)),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }